export default __webpack_public_path__ + "static/media/nuxt.2bbb95d1.svg";